import { i18n } from '@/locales';
export default {
    ECONNRESET: {
        code: 'ECONNRESET',
    },
    ECONNABORTED: {
        code: 'ECONNABORTED',
    },
    ENOTFOUND: {
        code: 'ENOTFOUND',
    },
    ETIMEDOUT: {
        code: 'ETIMEDOUT',
    },
    ECONNREFUSED: {
        code: 'ECONNREFUSED',
    },
    ERRADDRINUSE: {
        code: 'ERRADDRINUSE',
    },
    EADDRNOTAVAIL: {
        code: 'EADDRNOTAVAIL',
    },
    EHOSTUNREACH: {
        code: 'EHOSTUNREACH',
    },
    ENOENT: {
        code: 'ENOENT',
    },
    ENOTDIR: {
        code: 'ENOTDIR',
    },
    EACCES: {
        code: 'EACCES',
    },
    EEXIST: {
        code: 'EEXIST',
    },
    EPERM: {
        code: 'EPERM',
    },
    /** AbortController에 의해 abort될 시 나타나는 에러 코드. */
    ERR_CANCELED: {
        code: 'ERR_CANCELED',
        message: i18n.t('canceled'),
    },
};
